import {AxiosPromise} from "axios"
import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"
import {AttributeData} from "../store/entities/Attribute"
import {IGroupRule} from "./ProductRulesApi"

export default class AttributesApi {
    public static getAttributes(category_id: number): AxiosPromise<ActionAnswer<{ category_title: string, attributes: AttributeData[] }>> {
        return RequestHelper.send("get", "attributes&action=getAttributes", {category_id})
    }

    public static updateAttributes(category_id: number): AxiosPromise<ActionAnswer<IGroupRule>> {
        return RequestHelper.send("get", "attributes&action=updateAttributes", {category_id})
    }

}